/* eslint-disable react/prop-types */
/* eslint-disable max-len */
// Import Swiper React components
import React from 'react';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import './BrandsSlider.scss';
import 'swiper/swiper-bundle.css';

/** @namespace Mspwa/Component/BrandSlider/BrandsSlider/BrandsSlider */
export const BrandsSlider = ({ brands }) => {
    SwiperCore.use([Navigation, Autoplay]);
    return (
        <div className="Brands">
            <div className="Brands-Top">
                <h1 className="Brands-Top-Name">Top Brands</h1>
                <div className="Brands-Top-Img">
                    <svg
                      className="prevBrand Brands-Top-Img-ArrowLeft"
                      xmlns="http://www.w3.org/2000/svg"
                      width="31"
                      height="20"
                      viewBox="0 0 31 20"
                    >
                        <path
                          id="Left_arrow"
                          data-name="Left arrow"
                          className="cls-1"
                          d="M1456,2584h28a1,1,0,0,1,0,2h-28A1,1,0,0,1,1456,2584Zm7.32-8.71-9.03,9.03a0.983,0.983,0,1,0,1.39,1.39l9.03-9.03A0.983,0.983,0,1,0,1463.32,2575.29Zm-7.64,9,9.03,9.03a0.983,0.983,0,1,1-1.39,1.39l-9.03-9.03A0.983,0.983,0,1,1,1455.68,2584.29Z"
                          transform="translate(-1454 -2575)"
                        />
                    </svg>

                    <svg
                      className="nextBrand Brands-Top-Img-ArrowRight"
                      xmlns="http://www.w3.org/2000/svg"
                      width="31"
                      height="20"
                      viewBox="0 0 31 20"
                    >
                        <path
                          id="Right_arrow"
                          data-name="Right arrow"
                          className="cls-1"
                          d="M1505,2584h28a1,1,0,0,1,0,2h-28A1,1,0,0,1,1505,2584Zm20.68-8.71,9.03,9.03a0.983,0.983,0,1,1-1.39,1.39l-9.03-9.03A0.983,0.983,0,1,1,1525.68,2575.29Zm7.64,9-9.03,9.03a0.983,0.983,0,1,0,1.39,1.39l9.03-9.03A0.983,0.983,0,1,0,1533.32,2584.29Z"
                          transform="translate(-1504 -2575)"
                        />
                    </svg>
                </div>
            </div>

            <Swiper
              style={ {} }
              navigation={ {
                  prevEl: '.prevBrand',
                  nextEl: '.nextBrand'
              } }
              autoplay={ {
                  delay: 5000
              } }
              breakpoints={ {
                  1000: {
                      slidesPerView: 6
                  },
                  811: {
                      slidesPerView: 3
                  },
                  500: {
                      slidesPerView: 3
                  },
                  10: {
                      slidesPerView: 3
                  }
              } }
            >
                { brands.map((brand) => (
                    <SwiperSlide key={ brand.id }>
                        <img
                          className="Brands-ImgMain"
                          src={ brand.image }
                          alt=""
                        />
                    </SwiperSlide>
                )) }
            </Swiper>
        </div>
    );
};

export default BrandsSlider;
